// 项目管理模块

//新增项目定义
function addProjectCategory(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSaveComObjType", jsonstr: JSON.stringify(data) },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status === "ok" ? true : false);
      }
    });
  });
}

//获取用户定义的项目类别
function getCategory() {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetComObjTypeList" },
      success: res => {
        let str = JSON.parse(res);
        if (str.status === "ok") {
          resolve(Array.isArray(str.msg) ? str.msg : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//创建项目
function createProject(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSaveComObj", jsonstr: JSON.stringify(data) },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status === "ok" ? str.msg : false);
      }
    });
  });
}

//获取项目列表
function getProjectList(pageNum = 1) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetObjList", countNum: 10, currpage: pageNum },
      success: res => {
        let str = JSON.parse(res);
        if (str.status === "ok") {
          resolve(str.msg ? str.msg : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取企业绑定的企业
function projectCompany(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetEntList", strjson: JSON.stringify(data) },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? { msg: str.msg, totalcount: str.totalcount } : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取企业绑定的职位
function projectJobs(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetObjJobList", strjson: JSON.stringify(data) },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? { msg: str.msg, totalcount: str.totalcount } : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//项目绑定企业
function bindCompany(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSaveEntList", strjson: JSON.stringify(data) },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//项目绑定职位
function bindJobs(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSaveJobList", strjson: JSON.stringify(data) },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//直接绑定职位
function jobBindProject(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSaveJobListAndEnt", strjson: JSON.stringify(data) },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//删除项目
function deleteProject(id) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bdelobjlist", nationcode: "", objid: id },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//下线项目
function offlineProject(objid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSetComObjOffLine", nationcode: "", objid },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//解绑项目职位
function seperateJob(objid, jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bdelobjjob", nationcode: "", objid, jobid },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//解绑项目企业
function seperateCompany(objid, entid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bdelobjent", nationcode: "", objid, entid },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//设置项目职位下线
function offlineObjJob(objid, jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSetComObjJobOffLine", nationcode: "", objid, jobid },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//设置项目企业下线
function offlineObjCompany(objid, entid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bSetComObjEntOffLine", nationcode: "", objid, entid },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status === "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

export default {
  addProjectCategory,
  getCategory,
  createProject,
  getProjectList,
  projectCompany,
  projectJobs,
  bindCompany,
  bindJobs,
  jobBindProject,
  deleteProject,
  offlineProject,
  seperateJob,
  seperateCompany,
  offlineObjJob,
  offlineObjCompany
};
